import { useEffect } from 'react';
import {
  Typography,
  Container,
  Grid,
  styled,
  Paper,
  useTheme,
  useMediaQuery,
  Box,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
  Table,
} from '@mui/material';
import Page from '../components/Page';
import { useSelector } from 'react-redux';
import { getMyPayments, myPayments } from '../features/payments/paymentsSlice';
import { store } from '../store';
import config from '../config';

const PaymentsWrapper = styled(Paper)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem 2rem 1rem 1rem',
}));

const TableTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '.85rem',
  color: theme.palette.grey[400],
}));

const TableRegular = styled(Typography)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '.85rem',
  color: theme.palette.grey[500],
}));
const Section = styled(Box)(({ theme }) => ({
  padding: 0,
  marginTop: '1rem',
  paddingBottom: '1.875rem',

  [theme.breakpoints.up('sm')]: {
    marginTop: 'unset',
    padding: '1.875rem',
  },
}));

const formatDate = (stringDate: string) => {
  const date = new Date(stringDate);
  const formattedDate = date
    .toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  return formattedDate;
};

export default function MyPayments() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));

  const payments = useSelector(myPayments);

  useEffect(() => {
    store.dispatch(getMyPayments());
  }, []);

  return (
    <Page>
      <Section>
        <Container>
          <Grid
            container
            padding={'1.875rem'}
            justifyContent="center"
            direction={desktop ? 'row' : 'column'}
          >
            <Grid item sm={8} sx={{ alignSelf: 'center' }}>
              <PaymentsWrapper>
                <Typography variant="subtitle1" mb="1rem">
                  Mis Pagos
                </Typography>
                {payments.length >= 1 ? (
                  <TableContainer component={Paper}>
                    <Table
                      sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="simple table"
                    >
                      <TableHead sx={{ height: '2.5rem' }}>
                        <TableRow>
                          <TableCell align="center">
                            <TableTitle>Imponible</TableTitle>
                          </TableCell>
                          <TableCell align="center">
                            <TableTitle>Fecha</TableTitle>
                          </TableCell>
                          <TableCell align="center">
                            <TableTitle>Método de pago</TableTitle>
                          </TableCell>
                          <TableCell align="center">
                            <TableTitle>Períodos</TableTitle>
                          </TableCell>
                          <TableCell align="center">
                            <TableTitle>Total</TableTitle>
                          </TableCell>
                          <TableCell align="center">
                            <TableTitle>Estado</TableTitle>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          payments.map((payment, i) => (
                            <TableRow
                              key={i}
                              sx={{ height: '2.5rem', '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell align="center">
                                <TableRegular>
                                  {payment.imponible_tipo}-{payment.imponible_numero}
                                </TableRegular>
                              </TableCell>
                              <TableCell align="center">
                                <TableRegular>
                                  {formatDate(payment.updated_at)}
                                </TableRegular>
                              </TableCell>

                              <TableCell align="center">
                                <TableRegular>
                                  {payment.method[0].toUpperCase() + payment.method.substring(1)}
                                  {
                                    payment.method === 'decidir'
                                      ? <>
                                        <br />{payment.payment && payment.payment.method_text ? payment.payment.method_text : '-'}
                                      </>
                                      : null
                                  }
                                </TableRegular>
                              </TableCell>

                              <TableCell align="center">
                                <TableRegular>
                                  {
                                    payment.items.length > 1
                                      ? `${payment.items[0].period} al ${payment.items.slice(-1)[0].period}`
                                      : payment.items.length === 1
                                        ? `${payment.items[0].period}`
                                        : ' - '
                                  }
                                </TableRegular>
                              </TableCell>
                              <TableCell align="right">
                                <TableRegular>
                                  $ {(payment.total === null ? 0 : parseFloat(payment.total)).toFixed(2)}
                                </TableRegular>
                              </TableCell>
                              <TableCell align="center">
                                {
                                  payment.status === 'Completed'
                                    ? <>
                                      Pagado<br />
                                      <small><a href={`${config.api.url}/pdf/comprobante/${payment.comprobante_tipo}-${payment.comprobante_numero}`} target="_blank" rel="noopener noreferrer">
                                        Ver comprobante
                                      </a></small>
                                    </>
                                    : 'Pendiente'
                                }
                              </TableCell>
                            </TableRow>
                          ))
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <>
                    <Typography>
                      No hay pagos completados para mostrar
                    </Typography>
                  </>
                )}
              </PaymentsWrapper>
            </Grid>
          </Grid>
        </Container>
      </Section>
    </Page>
  );
}
